import React from 'react';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { RipsLobbyScreen } from '@/feature/lobby-rips/screens/RipsLobby';
import { PromoHubStack } from '@/feature/promohub/PromohubStack';

import { RipsLobbyStackParamList } from './types';

const Stack = createNativeStackNavigator<RipsLobbyStackParamList>();

export const LobbyStack = () => {
    return (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
            <Stack.Screen name="RipsLobbyScreen" component={RipsLobbyScreen} />
            <Stack.Screen name="LobbyPromohub" component={PromoHubStack} />
        </Stack.Navigator>
    );
};
